import { BlackBoxGenerator } from "./types"

// immediately resolve with nothing
const promise: Promise<unknown> = new Promise((resolve) => resolve(undefined))

export function* noop(): BlackBoxGenerator {
  yield promise
}
